import type { CompanyDetails } from "../api/contentful";

export const DEFAULT_BUSINESS_ORDER_EMAIL = "orders@alnarpsfarm.se";

export function getBusinessOrderEmail(
  companyDetails: CompanyDetails | null | undefined,
): string {
  if (!companyDetails) return DEFAULT_BUSINESS_ORDER_EMAIL;
  return companyDetails.businessOrderEmail.trim() || DEFAULT_BUSINESS_ORDER_EMAIL;
}
